<template>
  <el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
    <div class="clients-panel cash-list">
      <div class="clients-panel-container">
        <el-row class="black-inputs">
          <div class="cash-header">
            <div class="nav-toggle" @click="showHideScreenEvents">
              <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
            </div>
            <div class="screen-title">Évènements</div>
          </div>
          <el-row>
            <el-col :md="{ span: 4, offset: 10 }" :xs="24" :sm="{ span: 12, offset: 12 }">
              <el-button type="primary" @click="editEventInfos(null, null, null)">Créer un évènement</el-button>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="black-inputs">
          <el-col :md="24" class="screen-clients">
            <el-table ref="multipleTable" :data="getEventsList">
              <el-table-column prop="name" label="Nom" sortable>
              </el-table-column>
              <el-table-column prop="title" label="Titre" sortable>
              </el-table-column>
              <el-table-column prop="startDate" label="Début" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.startDate) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="endDate" label="Fin" sortable>
                <template slot-scope="scope">
                  <span>{{ dateRenderer(scope.row.endDate) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type" sortable>
                <template slot-scope="scope">
                  <span v-if="strUcFirst(scope.row.type) !== 'N'">{{ strUcFirst(scope.row.type) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="days" label="Jours" sortable>
                <template slot-scope="scope">
                  <span v-if="getDaysIsVisible(scope.row)">{{ scope.row.days.join(', ') }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label=" " width="70">
                <template slot-scope="scope">
                  <el-popover placement="top" v-model="scope.row.popupLinkEvent"
                    popper-class="popup-delete black-inputs">
                    <p>
                      <el-col v-if="getLink(scope.row) !== ''" :span="24" @click="copylink(scope.row)"
                        class="screen-fake-input">
                        <span @click="copylink(scope.row)" id="link">{{ getLink(scope.row) }}</span>
                        <i @click="copylink(scope.row)" style="padding-left: 10px; cursor:pointer"
                          class="el-icon-document-copy"></i>
                      </el-col>
                    </p>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" class="dark" type="primary"
                        @click="scope.row.popupLinkEvent = false">Fermer</el-button>
                      <!-- <el-button type="primary" size="mini" @click="deleteEvent(scope.row)">Confirmer</el-button> -->
                    </div>
                    <el-button style="width: auto" round class="dark" type="primary" slot="reference">
                      <span><i class="el-icon-link"></i></span>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-button class="dark" type="primary" @click="editEventInfos(scope.row)">
                    <span class="mobile-show"><i class="el-icon-edit"></i></span>
                    <span class="mobile-hide">Modifier</span>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <el-popover placement="right" width="200" trigger="manual" v-model="scope.row.popupValidDelete"
                    popper-class="popup-delete black-inputs">
                    <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                    <el-input v-model="checkPassValue" type="password"></el-input>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" class="dark" type="primary"
                        @click="scope.row.popupValidDelete = false">Annuler</el-button>
                      <el-button type="primary" size="mini" @click="deleteEvent(scope.row)">Confirmer</el-button>
                    </div>
                    <el-button slot="reference" @click="scope.row.popupValidDelete = !scope.row.popupValidDelete"
                      class="red">
                      Supprimer
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 30px;">
              <el-pagination background layout="prev, pager, next" :total="total" @current-change="current_change">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-container>
</template>

<script>
import { Notification } from 'element-ui';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { arrayOfTimestamp } from '../../tools/timeTool';

export default {
  name: 'EventList',
  components: {},
  data() {
    return {
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      loadingDelete: false,
      checkPassValue: ''
    }
  },
  computed: {
    ...mapGetters({
      getAllEvents: 'events/getAllEvents',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getEventsList: function () {
      // clone days
      this.loading = true

      if (this.getAllEvents.length > 0) {
        // ordering main ts datas
        let orderEventTab = this.getAllEvents.sort(function (a, b) {
          if (a.dates && b.dates && a.dates.length > 0 & b.dates.length > 0) {
            return (new Date(a.dates[0]).getTime() > new Date(b.dates[0]).getTime()) ? 1 : -1
          } else {
            return 1
          }
        })

        // format data for tab display
        let formatedTab = []
        orderEventTab.forEach((event) => {
          let typeCash = 'Normal'
          if (event && event.services && event.services[event.days[0]] && event.services[event.days[0]].cashOn) {
            typeCash = event.services[event.days[0]].cashType
          }
          let start = ''
          let end = ''
          if (event.dates && event.dates.length > 0) {
            start = new Date(event.dates[0])
            end = new Date(event.dates[1])
          }
          formatedTab.push({
            name: event.name,
            title: event.title,
            days: event.days,
            startDate: start,
            endDate: end,
            type: typeCash,
            id: event.id,
            popupValidDelete: false
          })
        })

        this.total = formatedTab.length
        this.loading = false
        return formatedTab.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
      }
      this.loading = false
      return []
    }
  },
  created: function () { },
  methods: {
    ...mapActions({
      deleteEventById: 'events/deleteEventById',
      showHideScreenEvents: 'displayer/showHideScreenEvents',
      checkPassword: 'newUsers/checkPassword'
    }),
    ...mapMutations({
      setDialogError: 'displayer/setDialogError',
      setDialogEditEvent: 'displayer/setDialogEditEvent',
      setSelectedEventById: 'events/setSelectedEventById',
      clearSelectedEvent: 'events/clearSelectedEvent'
    }),
    getDaysIsVisible: function (el) {
      if (el.startDate && el.endDate && el.startDate.getTime() !== el.endDate.getTime()) {
        let nbDays = Math.ceil((el.endDate.getTime() - el.startDate.getTime()) / (1000 * 3600 * 24)) + 1
        if (nbDays < 7 && nbDays !== el.days.length) return true
      }
      if (el.days.length < 7 && !el.startDate) {
        return true
      }
      return false
    },
    getLink: function (el) {
      if (!el || !el.id) return ''
      let host = `http://${window.location.hostname}`
      return `${host}/event-new/${this.getUidPublic}/${el.id}`
    },
    copylink: async function (el) {
      let host = `http://${window.location.hostname}`
      let link = `${host}/event-new/${this.getUidPublic}/${el.id}`
      try {
        await navigator.clipboard.writeText(link)
        el.popupLinkEvent = false
        Notification.success({
          title: 'Lien copié',
          message: "Le lien de l'évènement à été copié avec success",
          position: 'bottom-right'
        })
      } catch (err) {
        console.error('Failed to copy: ', err)
      }
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage
    },
    strUcFirst: function (a) {
      return ((`${a}`).charAt(0).toUpperCase() + a.substr(1))[0]
    },
    dateRenderer: function (date) {
      if (date) {
        return `${this.leadingZero(date.getDate())}/${this.leadingZero(date.getMonth() + 1)}/${date.getFullYear()}`
      } else {
        return '-'
      }
    },
    leadingZero(value) {
      return (`0${value}`).slice(-2)
    },
    createNewEventEntry: function () {
      // Check entrys
      if (this.getEntrysIsValid) {
        // is valid
        let days = arrayOfTimestamp(this.datesCash[0], this.datesCash[1])
        // create entry
        this.createDaysAndService({
          days: days,
          service: this.serviceCash,
          content: {
            type: this.typeCash,
            value: Number(this.priceCash),
            nbCouv: Number(this.nbCouv),
            limitHour: this.limitHour
          }
        }).then(() => {
          this.datesCash = {}
          this.typeCash = ''
          this.serviceCash = ''
          this.priceCash = null
          this.nbCouv = null
          this.limitHour = null
        }).catch((err) => {
          console.error(err)
        })
      } else {
        // if not valid -> show popup notif error or something like this
        this.setDialogError(true)
      }
    },
    editEventInfos: function (event) {
      if (event && event.id) this.setSelectedEventById(event.id)
      else this.clearSelectedEvent()
      this.setDialogEditEvent(true)
    },
    deleteEvent: function (el) {
      this.checkPassword(this.checkPassValue).then(() => {
        this.loadingDelete = true
        this.deleteEventById(el.id).then(() => {
          this.loadingDelete = false
          el.popupValidDelete = false
          this.checkPassValue = ''
        })
      })
    },
    gotoEvent: function (id) {
      if (!id || id === '') return
      let host = `https://${window.location.hostname}`
      let link = `${host}/event/${this.getUidPublic}/${id}`
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/mixins";

.cash-list {
  button {
    height: 48px;
  }

  .el-col {
    @include mixins.mobile-landscape {
      margin-bottom: 10px;
    }

    @include mixins.mobile-portrait {
      margin-bottom: 10px;
    }
  }

  .el-range {
    &-editor {
      @include mixins.mobile-portrait {
        height: 100% !important;
        width: 100% !important;
        display: block;
        text-align: center;
      }
    }

    &__icon {
      @include mixins.mobile-portrait {
        display: block;
        width: 100%;
      }
    }

    &-input {
      @include mixins.mobile-portrait {
        display: block;
        height: 35px;
        width: 100%;
      }
    }

    &-separator {
      @include mixins.mobile-portrait {
        display: block;
        width: 90%;
      }
    }

    &__close-icon {
      @include mixins.mobile-portrait {
        top: 0;
        right: 10px;
        height: 35px;
        position: absolute;
      }
    }
  }
}

.inputEuro {
  text-align: center;

  &:after {
    content: '€';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 16px;
  }
}

.inputCouv {
  text-align: center;

  &:after {
    content: 'couv.';
    position: absolute;
    font-weight: 100;
    right: 20px;
    font-size: 14px;
  }
}

.el-input__inner {
  text-align: center;
  width: 100%;
}

.mobile-show {
  display: none;

  @include mixins.mobile-landscape {
    display: block;
  }
}

.mobile-hide {
  display: block;
  padding: 0 10px;

  @include mixins.mobile-landscape {
    display: none;
  }
}

.screen-fake-input {
  margin-bottom: 20px;
  text-align: center;
  font-weight: 400;
  background-color: var(--dark__main_color-dark);
  padding: 10px;
  -webkit-touch-callout: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>
